import Image from "next/image";
import { FC, useState } from "react";
import { ItalianExpertReadableTO } from "../../models/detail";
import styles from "../../styles/detail/DetailDescription.module.scss";

const PackageDetailDescriptionCard: FC<{
    cardData: ItalianExpertReadableTO;
}> = ({ cardData }) => {
    const [coverError, setCoverError] = useState(false);
    // const [avatarError, setAvatarError] = useState(false);
    return (
        <div className="w-100">
            <div className={styles.cardImageContainer}>
                <Image
                    src={
                        coverError
                            ? "/images/tours/across-italy-reduced.jpg"
                            : cardData.image
                    }
                    className={styles.imageDescription}
                    alt="card-image"
                    fill
                    onError={() => {
                        setCoverError(true);
                    }}
                />
            </div>
            {/* <div className={`${styles.cardDataContainer} mb-5`}>
                <div className={styles.cardImageProfileContainer}>
                    <Image
                        src={
                            !cardData.avatar || avatarError
                                ? "/images/tours/across-italy-reduced.jpg"
                                : cardData.avatar!
                        }
                        className={styles.imageProfile}
                        style={{
                            borderColor:
                                cardData && cardData.color
                                    ? cardData.color
                                    : "#00ff2a",
                        }}
                        alt="user-image"
                        width={40}
                        height={40}
                        onError={() => {
                            setAvatarError(true);
                        }}
                    />
                </div>
                <div className="ms-3">
                    <span className={styles.cardNameItalianExpert}>
                        {cardData.name}
                    </span>
                    <div>
                        <span className={styles.cardItalianExpert}>
                            Italian Expert
                        </span>
                    </div>
                </div>
            </div> */}
        </div>
    );
};

export default PackageDetailDescriptionCard;
